// Print views load a PDF in batches into vm.projectPages. Every load used to APPEND, so a second load (the documentUrl
// watcher plus reload, or the live PDF and then the version's) printed pages two or three times (23 Oct 2026). Each load
// now starts with beginPrintLoad, which clears the pages and takes a token; a batch from a superseded load drops itself.

export function beginPrintLoad(vm) {
    vm.printLoadToken = (vm.printLoadToken || 0) + 1;
    vm.projectPages = [];
    vm.loadPageReady = false;
    return vm.printLoadToken;
}

export function isCurrentPrintLoad(vm, token) {
    return vm.printLoadToken === token;
}


// WEBPACK FOOTER //
// ./src/lib/print-load.js